import React from 'react';
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid';
import ProfitRhinoAppIcon from 'housecall-ui/dist/IconsAndImages/AppIcons/ProfitRhinoAppIcon';
import { Typography } from 'housecall-ui/dist/library';

import ProfitRhinoButton from '../OtherComponents/ProfitRhinoButton';

const ProfitRhinoStrategy = {
  previewInfo: {
    name: 'Profit Rhino',
    iconSvg: <ProfitRhinoAppIcon size="jumbo" />,
    newTab: true,
  },
  headerInfo: {
    name: 'Profit Rhino',
    category: 'Featured',
    details: (
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Typography>
            Save time and control your profit with Housecall Pro&apos;s flat rate price book powered by Profit Rhino.
            Bringing 30 years of industry expertise, Profit Rhino can help you maximize profit, account for changing
            material costs, and provide a consistent experience for your customers.
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            With this feature, you can now access the standard Profit Rhino price books for HVAC, Plumbing, Electrical,
            and Drain Cleaning directly in your Housecall Pro account. Any customizations will take place within
            Housecall Pro. Contact our chat team to learn more and discuss how to get a powerful flat rate book set up
            in your Housecall Pro account
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontStyle: 'italic' }}>Take charge of your profit:</Typography>
          <Typography>
            <ul>
              <li>
                Incorporate overhead, labor, and material costs to automatically calculate a profitable price for every
                service
              </li>
              <li>Feel confident knowing exactly how much money you&apos;ll make on each job</li>
              <li>Easily control your profit by adjusting your material markups as costs change</li>
            </ul>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontStyle: 'italic' }}>Build trust with customers:</Typography>
          <Typography>
            <ul>
              <li>Offer a transparent, consistent experience every time customers book with you</li>
              <li>
                92% of customers prefer flat rate pricing, and are more likely to accept a job when flat rate is
                presented
              </li>
            </ul>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography style={{ fontStyle: 'italic' }}>Take the guesswork out of pricing:</Typography>
          <Typography>
            <ul>
              <li>
                The flat rate price book provides pre-built pricing on updated industry averages, so you&apos;re always
                turning a healthy profit
              </li>
              <li>
                Spend less time calculating pricing, and more time working on your business and delivering 5-star
                customer service
              </li>
            </ul>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography>
            Interested in learning more? Tap “Tell Me More” to chat with our team about adding Profit Rhino to your
            plan.
          </Typography>
        </Grid>
      </Grid>
    ),
    iconSvg: <ProfitRhinoAppIcon size="jumbo" />,
  },
  media: {
    wistiaLink: 'https://tryhousecall-1.wistia.com/medias/j8b7ytjzvy',
  },
  sellingPoints: {},
  planAvailability: {
    title: 'Housecall Pro Plan',
    description: (
      <Grid container spacing={8}>
        <Grid item xs={4}>
          <Typography align="left" variant="body1">
            Basic plan
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography align="right" variant="body1">
            Not Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            Available
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  price: {
    title: 'Housecall Pro Add-on Price',
    hideToggle: true,
    appActionButton: <ProfitRhinoButton />,
    description: (
      <Grid container spacing={8}>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            Essentials plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $149/month
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="left" variant="body1">
            MAX plan
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography align="right" variant="body1">
            + $149/month
          </Typography>
        </Grid>
      </Grid>
    ),
  },
  supportContacts: [],
};

export default ProfitRhinoStrategy;
